export const styles = {
  container: 'tw-flex tw-flex-col tw-gap-2 tw-p-6 tw-h-full',
  header: 'tw-flex tw-items-center tw-justify-between tw-h-page-header tw-shrink-0',
  title: 'tw-text-3xl tw-font-bold tw-text-white-800 tw-m-0 tw-leading-none',
  actions: 'tw-flex tw-items-center tw-gap-2',
  content: 'tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-overflow-hidden',
};
